import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';
import { infoSectionTitleStyles } from '@/components/Approval/@components/InfoSection/styles';

/** 저장 HTML(레거시 문서 포함)의 태그·클래스로 맞춤. 칸 색은 인라인 style */
export const SerpBulkStockAdjustmentRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'auto',
    minWidth: 720,
  },
  '& table + table, & table + .d-flex, & .mt-5 + .d-flex': {
    marginTop: 16,
  },
  '& .d-flex': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 8,
    '& > strong': {
      ...infoSectionTitleStyles,
    },
  },
  '& table th, & table td': {
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  '& table td.text-right': {
    textAlign: 'right',
  },
  '& tbody th': {
    fontWeight: 400,
  },
  '& tr[style*="bold"] > *': {
    fontWeight: 700,
  },
}));

export const SerpBulkDetailSheetBody = styled(Box)({
  padding: '16px 16px 24px',
});
